/**
 * Localization messages for RuleCard component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Ignore Rule': 'ruleRecs.ruleCard.ignoreRule',
  'Ignore Rule?': 'ruleRecs.ruleCard.ignoreRuleModalTitle',
  "Are you sure you want to ignore this rule recommendation? You can't get it back once it's gone.":
    'ruleRecs.ruleCard.ignoreRuleModalSubtitle',
  // label for the rule includes section (used in fluid card footer)
  'Rule Includes:': 'ruleRecs.ruleCard.ruleIncludes',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleCardMessage = keyof typeof invertedMessages;

export default invertedMessages;
